import { TemplateRef } from '@angular/core';

export class Contractor {
  contractorVendorCode: number;
  company: string;
}

export class WorkOrder {
  workOrderNo: string;
  workOrderCode: number;
}

export class ReportFilterModel {
  startDate: Date;
  contractorCode: number;
  workOrderNo: number;
  license: string;
  subContractorCode: number;
  subContractorWorkOrderNo: number;
  subContractorLicense: string;
  filterType: number;
  // FilterName: string;
}

export class ReportFilterData {
  id: number;
  filterType: string;
  templateRef: TemplateRef<any>;
  data: any;
}

export enum FilterTypeEnum {
  ContractorFilter = 1,
  SubContractorFilter = 2
}

export enum MasterItemCode {
  QUALIFICATION = 'GM331',
  TECHNICALQUALIFICATION = 'GM342',
  QUALIFICATIONSTREAM = 'GM352',
  RELIGION = 'GM362',
  // CASTS = 'GM845',
  CASTS = 'GM557',
  GENDER = 'GM302'
}
